const ProductFormLabels = {
  internalName: 'Product Name* (Internal)',
  productMasterId: 'Select HS Code',
  remark: 'Item Description',
  customer: 'Customer',
  supplier: 'Supplier',
  shipper: 'Shipper',
  newHsCode: 'New HS Code',
  hsCode: 'HS Code',
  skuCode: 'SKU Code',
};

const ProductColumns = {
  internalName: 'Internal Product Name',
  hsCode: 'HS Code',
  remark: 'Item Description',
};

export {
  ProductColumns,
  ProductFormLabels,
};
